/**
 * Created by Lenovo on 2017/5/18.
 */

import React, {
    Component,
    PropTypes
} from 'react';
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import {language,alertTip} from 'UTIL/common'
import {GetDateStr}from '../../function'
import SearchDate from 'CONFIG/component/search/searchDate'
import ellaService from 'SERVICES/purifier/ella/ellaService'
export default class UserInformationStatistics extends Component{
    constructor(props){
        super(props);
        this.state = {
           list : {},
        }
    }
    componentDidMount(){
        $("#StatisticsTime").val(GetDateStr(-6)+' 至 '+GetDateStr(0));
        this.getData();
    }
    getData(){
        var searchBgnTime = $("#StatisticsTime").val()==""?"":$("#StatisticsTime").val().split("至")[0];
        var searchEndTime  = $("#StatisticsTime").val()==""?"":$("#StatisticsTime").val().split("至")[1];
        if(searchBgnTime == ''){
            alertTip('请选择统计时间！');
        }else {
            var data = {
                searchBgnTime:$.trim(searchBgnTime),
                searchEndTime:$.trim(searchEndTime)
            }
            data = JSON.stringify(data);
            ellaService.userInsertStatistics({data}).then(body=>{
                console.log(body);
                var nameList = body.data.nameList;
                var valueList = body.data.valueList;
                this.getOption(nameList,valueList)
            })
        }
    }
    getOption(nameList,valueList){
        var colorList = [];
        var colors = ['#B5C334','#FCCE10','#E87C25','#27727B','#C1232B'];
        var j =0;
        for(let i=0;i<nameList.length;i++){
            colorList.push(colors[j]);
            console.log(j)
            if(j == colors.length-1){
                j = 0
            }else {
                j++;
            }
        }
        console.log(colorList)
        const option = {
            title : {
                text: '新增用户统计',
                x:'center',
            },
            tooltip : {
                trigger: 'axis',
            },
            // legend: {
            //     data:['增长数值']
            // },
            toolbox: {
                show : true,
                feature : {
                    mark : {show: true},
                    dataView : {show: true, readOnly: false},
                    magicType : {show: true, type: ['line', 'bar']},
                    restore : {show: true},
                    saveAsImage : {show: true}
                }
            },
            calculable : true,
            xAxis : [
                {
                    type : 'category',
                    data : nameList,
                    name:'日期',
                }
            ],
            yAxis : [
                {
                    name:'增长数值',
                    type : 'value'
                }
            ],
            series : [
                {
                    name:'增长数值',
                    type:'bar',
                    data:valueList,
                    itemStyle: {
                        normal: {
                            color: function(params) {
                                // build a color map as your need.
                                return colorList[params.dataIndex]
                            },
                            label: {
                                show: true,
                                position: 'top',
                                formatter: '{b}\n{c}'
                            }
                        }
                    },
                },

            ]
        };
        var chart = echarts.init(document.getElementById('main'));
        chart.setOption(option);
    }
    reset(){
        $("#StatisticsTime").val(GetDateStr(-6)+' 至 '+GetDateStr(0));
        this.getData();
    }
    btnSearch(){
        this.getData();
    }
    render(){
        return <div>
            <ContentHeader nameLg="StatisticalManagement" nameSm="UserInformationStatistics"/>
            <section className="content" >
                <div className="box box-primary color-palette-box">
                    <BoxHeader title={'UserInformationStatistics'} />
                    <div className="box-body">
                        <div className="title-box">
                            <div className="clearfix">
                                    <SearchDate name="StatisticsTime" id="StatisticsTime"/>
                                    <button type="button" className="btn btn-info" id="search"
                                            onClick={this.btnSearch.bind(this)}>{language()['query']}</button>
                                    &nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset"
                                            onClick={this.reset.bind(this)}>{language()['resetting']}</button>
                            </div>
                        </div>
                        <hr/>
                        <div id="main" class="main" style={{height:'500px',width:'100%'}}></div>
                    </div>
                </div>
            </section>
        </div>
    }
}



// WEBPACK FOOTER //
// ./modules/ella/statistics/userInformationStatistics.js